import { render, staticRenderFns } from "./RiskIndicatorBar.vue?vue&type=template&id=46186ab4&scoped=true"
import script from "./RiskIndicatorBar.vue?vue&type=script&lang=js"
export * from "./RiskIndicatorBar.vue?vue&type=script&lang=js"
import style0 from "./RiskIndicatorBar.vue?vue&type=style&index=0&id=46186ab4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_babel-core@7.0.0-bridge.0_@babel+core@7.26.7__cac_fzj6xqfhz2iur5pptcdfbzd24y/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46186ab4",
  null
  
)

export default component.exports